import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ENCODED_FILTER_SEL_PAR } from '../../components/filters/hooks/filter-names.constants';
import {
  postDecodeFilterSelection,
  postEncodeFilterSelection,
} from '../../services/get-encode-filter-selection.service';
import { FilterSelectedValue } from './interfaces/filter-selected-value.interface';
const RESET_FILTER_SEL_PAR_VALUE = 'reset';
export const useEncodeFilterSelection = (
  filterSelection: FilterSelectedValue[],
) => {
  const { data } = useQuery({
    queryKey: [filterSelection],
    queryFn: () =>
      filterSelection && filterSelection.length > 0
        ? postEncodeFilterSelection(filterSelection)
        : null,
  });
  return data;
};

export const useDecodeFilterSelection = (
  encoded: string | null | undefined,
  enabled: boolean,
) => {
  const { data } = useQuery({
    enabled,
    queryKey: [encoded],
    queryFn: () => postDecodeFilterSelection(encoded ?? ''),
    placeholderData: keepPreviousData,
  });
  return data;
};

/**
 * This will take the encoded filters in the URL and decoded it.
 * Once the filters are transformed in a filter selection list, it will stop checking the URL parameter.
 * This allow us to have a filter selection the first time the application loads.
 * @returns
 */
export const useDecodeProvider = () => {
  const [searchParams, setSearchParam] = useSearchParams();
  const [encoded, setEncoded] = useState<string | null | undefined>();
  const [enableDecode, setEnableDecode] = useState<boolean>(false);
  const [par, setPar] = useState<string | null | undefined>();
  useEffect(() => {
    const par = searchParams.get(ENCODED_FILTER_SEL_PAR);
    setPar(par);
  }, [searchParams]);

  useEffect(() => {
    if (
      encoded === undefined &&
      par !== undefined &&
      par !== RESET_FILTER_SEL_PAR_VALUE
    ) {
      setEncoded(par);
      setEnableDecode(true);
    }
  }, [encoded, par]);

  useEffect(() => {
    // This is to reload filter selection from the query string params.
    if (par !== undefined && par === RESET_FILTER_SEL_PAR_VALUE) {
      setEncoded(undefined);
      setEnableDecode(false);
      searchParams.set(ENCODED_FILTER_SEL_PAR, '');
      setSearchParam(searchParams, { replace: true });
    }
  }, [par, searchParams, setSearchParam]);

  const inittialFilterSelection = useDecodeFilterSelection(
    encoded,
    enableDecode,
  );

  return inittialFilterSelection;
};
